import React, { Component } from 'react';
import ClaimDetails from "./EMDCGClaimDetails";
import Attachment from "./EMDCGAttachment";
import DisputeDetails from "./EMDCGDisputeDetails";
import DisputeRequestor from "./EMDCGDisputeRequestor";
import CCEmail from "../wepcg/CCEmail.js";
import EMDCGDisputeRequest from "./EMDCGDisputeRequest";

import "../css/Tempate1.css"
import SerialNumber from "../empcg/SerialNumber";

const Type1 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>
                1. The damage must be clearly visible on the picture. Photos need to show the details of the box and pallet labels and the serial number on the machine itself, so that photos can be paired without any doubt.
            </li>
            <li>
                2. Please attach POD with marked damage.
            </li>
            <li>
                3. Claim has to be raised within five (5) working days after the date of delivery.
            </li>
        </ul>
    </div>
}
const Type2 = () =>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>1. Claim will be rejected if your goods have not been confirmed as not delivered due to
                Lenovo.
            </li>
            <li>2. The goods delivery status is available at <a target="_blank" href="https://ovp.lenovo.com/lenovo-ovp-new/login" style={{color:"#dc291e"}}>Order Visibility Portal</a> or enquire with your
                Customer Fulfillment Representative.
            </li>
            <li>3. If POD not available in OVP contact your Customer Fulfillment Representative.</li>
            <li>4. Contact your Customer Fulfillment Representative to obtain confirmation of delivery delay
                (mandatory attachment).
            </li>
            <li>5. <strong>Approved claim is only related to the late payment charges calculation and may not
                result in payment terms extension.</strong></li>
        </ul>
    </div>
}
const Type4 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>
                1. Claim will be rejected if your goods have not been confirmed lost by Lenovo.
            </li>
            <li>
                2. The goods delivery status is available at <a target="_blank" href="https://ovp.lenovo.com/lenovo-ovp-new/login"><span style={{color:"#dc291e"}}>Order Visibility Portal </span></a> or enquire with your Customer Fulfillment Representative.
            </li>
            <li>
                3. If POD not available in OVP, contact your Customer Fulfillment Representative.
            </li>
            <li>
                4. Claim has to be raised within five (5) working days after the date of delivery.
            </li>
        </ul>
    </div>
}
const Type5 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>1. For more information, check <a style={{color:"#dc291e"}} href="/assets/downLoadFile/Lenovo-PCG-DCG-Services-Credit-Cancellation-Process-EMEA.pdf" target="_blank">Lenovo PCG & DCG Services Credit / Cancellation Process.</a></li>
        </ul>
    </div>
}
const Type6 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>1. The damage is caused in manufacturing – Box Intact.</li>
            <li>2. Claim has to be raised within five (5) working days after the date of delivery.</li>
        </ul>
    </div>
}
const Type7 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>1. To prevent rejections on the basis of incorrect submission, please check the difference between "Pricing Error" and "Price Protection" disputes.</li>
            <li>2. If there is a possibility of incorrect price because of the price drop, please check internally with your responsible department if the price protection credit note was issued already.</li>
        </ul>
    </div>
}
const Type8 =()=>{
    return <div style={{marginLeft:"41.6%"}}>
        <span style={{textDecoration:"underline"}}>Important notice:</span>
        <ul style={{listStyle:'none',paddingLeft:0}}>
            <li>1. Regarding the DOA claim for Ideapad laptops and ultrabooks within SK, CZ and PL, please contact MEDION at returns-ra@medion.com otherwise the claim will be rejected.</li>
            <li>2. We are not able to process claim with incorrect Serial Numbers.</li>
        </ul>
    </div>
}

class WEDCGTemplate1 extends Component{
    constructor(props) {
        super(props);
        this.state={
            invoiceNumbers:'',
            formRef:props.formRef,
        }
        this.handleChange = info => {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-2);
            fileList = fileList.map(file => {
                if (file.response) {
                    file.url = file.response.url;
                }
                return file;
            });

            this.setState({ fileList });
        };
        this.uploadProps={
            // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
            onChange: this.handleChange,
            multiple: true,
            maxCount:1
        };
    }
    render() {

        return <div>
                {
                    this.props.type==1?
                        <Type1 />:
                    this.props.type==2?
                        <Type2 /> :
                    this.props.type==4?
                        <Type4 /> :
                    this.props.type==5?
                        <Type5 />:
                    this.props.type==6?
                        <Type6 />:
                    this.props.type==7?
                        <Type7 />:
                    this.props.type==8?
                        <Type8 />:''
                }
            {this.props.type==12?
                ''
                :this.props.type==8?
                    <SerialNumber {...this.props} regin={'WEDCG'} />
                :
                <ClaimDetails {...this.props} />
            }
            {this.props.type==12?'':
                <Attachment type={this.props.type}/>
            }
            <DisputeDetails {...this.props} type={this.props.type}/>
            <DisputeRequestor type={this.props.type} />
            <CCEmail />
        </div>
    }
}

export default WEDCGTemplate1;